import Swiper from "swiper";
import "swiper/css/scrollbar";
import { Navigation } from "swiper/modules";
import { customFadeInTopElem } from "assets/animations";

export const animateSlides = (items, parentElem) => {
	items?.forEach((item, index) => {
		if (!item.classList.contains("animated"))
			customFadeInTopElem({ elem: item, parentElem, index });
	});
};

const getVisibleSlides = (thisSwiper) => {
	const slidesInView = [];
	for (
		let i = thisSwiper.activeIndex;
		i < thisSwiper.activeIndex + thisSwiper.params.slidesPerView;
		i++
	) {
		if (thisSwiper.slides[i]) {
			if (!thisSwiper.slides[i]?.classList.contains("animated"))
				slidesInView.push(thisSwiper.slides[i]);
		}
	}

	return slidesInView;
};

export const swiperCreateNew = (sectionId) => {
	const thisSection = document.getElementById(sectionId);
	const swiperElem = thisSection?.querySelector(".swiper");
	const prevEl = thisSection?.querySelector(".nav-prev");
	const nextEl = thisSection?.querySelector(".nav-next");

	const thisSwiper = new Swiper(swiperElem, {
		init: false,
		modules: [Navigation],
		slidesPerView: 1,
		spaceBetween: 0,
		grabCursor: true,
		navigation: {
			prevEl,
			nextEl,
		},
	});

	thisSwiper.on("init", (swiper) => {
		animateSlides(getVisibleSlides(swiper), thisSection);
	});

	thisSwiper.init();

	thisSwiper.on("slideChange", (swiper) => {
		animateSlides(getVisibleSlides(swiper), thisSection);
	});

	return thisSwiper;
};
